import { FETCH_TICKET_ALERT_SETTINGS, FETCH_TICKET_SETTINGS } from "../constants/tickets";

const initialState = {
  ticketAlertSettings: null,
  ticketSettings: null,
};

export default function tickets(state = initialState, action) {
  switch (action.type) {
    case FETCH_TICKET_ALERT_SETTINGS:
      return { ...state, ticketAlertSettings: action.data };
      case FETCH_TICKET_SETTINGS:
        return { ...state, ticketSettings: action.data[0] };
        
    default:
      return state;
  }
}
